import React from "react";
import { Button } from "@mui/material";

const MDButton = ({
  variant = "contained",
  color = "primary",
  size = "medium",
  circular = false,
  iconOnly = false,
  children,
  sx,
  ...rest
}) => {
  const customSx = {
    borderRadius: circular ? "50%" : "0.5rem",
    minWidth: iconOnly ? "auto" : undefined,
    width: iconOnly ? "40px" : undefined,
    height: iconOnly ? "40px" : undefined,
    textTransform: "none",
    fontWeight: 400,
    ...sx,
  };

  return (
    <Button variant={variant} color={color} size={size} sx={customSx} {...rest}>
      {children}
    </Button>
  );
};

export default MDButton;
